import { FC, useCallback, useMemo, useRef } from 'react';
import { Animated, ImageResizeMode } from 'react-native';

import { isWebPlatform } from '../../../boot/utils';
import { LAYOUT_MAX_WIDTH } from '../../../constants/layout';
import { CoverSourceType } from '../types';
import CoverImage from './CoverImage';
import S from './style';

export interface Props {
  coverHeight: number;
  style?: any;
  coverSource?: CoverSourceType;
  coverResizeMode?: ImageResizeMode;
  bgColor?: string;
  showPlaceholder?: boolean;
  onLoadEnd?: () => void;
}

const Cover: FC<Props> = ({
  coverSource,
  coverHeight,
  coverResizeMode,
  bgColor,
  style,
  showPlaceholder,
  onLoadEnd,
}) => {
  const placeholderOpacity = useRef(
    new Animated.Value(showPlaceholder ? 1 : 0)
  );

  const handleCoverLoadEnd = useCallback(() => {
    Animated.timing(placeholderOpacity.current, {
      duration: 500,
      toValue: 0,
      useNativeDriver: !isWebPlatform,
    }).start();

    onLoadEnd?.();
  }, [onLoadEnd]);

  const placeholderStyle = useMemo(() => {
    return { opacity: placeholderOpacity.current };
  }, []);

  return (
    <S.Cover height={coverHeight} bgColor={bgColor} style={style}>
      {!showPlaceholder && (
        <CoverImage
          coverSource={coverSource}
          onLoadEnd={handleCoverLoadEnd}
          coverResizeMode={coverResizeMode}
        />
      )}
      <S.Placeholder
        width={LAYOUT_MAX_WIDTH}
        height={coverHeight}
        style={placeholderStyle}
      />
    </S.Cover>
  );
};

export default Cover;
